import { state } from '../core/state.mjs';
import { CONFIG } from '../core/config.mjs';
import { testAvifSupport, testWebPSupport } from './format-support.mjs';

/**
 * Détecte formats image supportés avec cache
 */
export function detectFormats() {
    if (state.formatsPromise) {
        return state.formatsPromise;
    }

    state.formatsPromise = new Promise(async (resolve) => {
        const formats = { avif: false, webp: false };

        if (!CONFIG.formats.autoDetect) {
            if (CONFIG.formats.preferredFormat === 'avif') {
                formats.avif = true;
            } else if (CONFIG.formats.preferredFormat === 'webp') {
                formats.webp = true;
            }

            state.formats = formats;
            return resolve(formats);
        }

        if (CONFIG.formats.checkWebP) {
            formats.webp = testWebPSupport();
        }

        if (CONFIG.formats.checkAvif) {
            formats.avif = await testAvifSupport();
        }

        if (CONFIG.debug) {
            console.log(`[AI] Formats: AVIF=${formats.avif}, WebP=${formats.webp}`);
        }

        state.formats = formats;
        resolve(formats);
    });

    return state.formatsPromise;
}
